/* Millian club drawer runtime. Lives in an ASSET, not inline in the
   selector snippet: the snippet renders inside the drawer's cart!=empty
   gate, and scripts arriving later via ajax innerHTML swaps never
   execute — a first session starting with an empty cart had a fully
   dead club UI until a reload. Loaded unconditionally by
   cart-drawer.liquid with defer. */
  // Instant audience bootstrap: club-selected is in the server-rendered
  // state JSON and member status is cached from the last visit, so card
  // prices paint the right tier before first render instead of flashing
  // guest values until the app-proxy fetch answers.
  if (!window.__millianAudienceBoot) {
    window.__millianAudienceBoot = true;
    try {
      var mbStateEl = document.querySelector('[data-millian-cart-state]');
      var mbState = mbStateEl ? JSON.parse(mbStateEl.textContent) : null;
      if (mbState && mbState.clubSelected) document.documentElement.classList.add('millian-club-selected');
    } catch (e) {}
    try {
      if (sessionStorage.getItem('millian:member') === '1') document.documentElement.classList.add('millian-is-member');
    } catch (e) {}
    if (window.millianPaintCardPrices) window.millianPaintCardPrices();
  }

  // Cart calls must NOT ride the page's network stack: third-party scripts
  // patch BOTH window.fetch and XMLHttpRequest here and have been observed
  // stalling cart requests for 45s+ (their analytics backend erroring),
  // which made the club toggle feel dead. A hidden about:blank iframe's
  // fetch is native and unpatched — that is the transport; page-level XHR
  // is only the fallback if the iframe is unavailable.
  if (!window.__millianXhr) {
    (function () {
      var frame = null;
      function nativeFetch() {
        try {
          if (!frame || !frame.contentWindow || !frame.isConnected) {
            frame = document.createElement('iframe');
            frame.style.display = 'none';
            frame.setAttribute('aria-hidden', 'true');
            frame.src = 'about:blank';
            (document.body || document.documentElement).appendChild(frame);
          }
          var w = frame.contentWindow;
          if (w && w.fetch) return w.fetch.bind(w);
        } catch (e) { /* sandboxed or blocked: fall back to XHR */ }
        return null;
      }
      function xhrFallback(url, opts) {
        return new Promise(function (resolve, reject) {
          var x = new XMLHttpRequest();
          x.open(opts.method || 'GET', url);
          x.withCredentials = true;
          var headers = opts.headers || {};
          for (var k in headers) x.setRequestHeader(k, headers[k]);
          x.timeout = 15000;
          x.onload = function () {
            resolve({
              ok: x.status >= 200 && x.status < 300,
              status: x.status,
              json: function () { return Promise.resolve(JSON.parse(x.responseText)); },
              text: function () { return Promise.resolve(x.responseText); },
            });
          };
          x.onerror = function () { reject(new Error('network error: ' + url)); };
          x.ontimeout = function () { reject(new Error('timeout: ' + url)); };
          x.send(opts.body || null);
        });
      }
      window.__millianXhr = function (url, opts) {
        opts = opts || {};
        var native = nativeFetch();
        if (!native) return xhrFallback(url, opts);
        var timeout = new Promise(function (ignore, reject) {
          setTimeout(function () { reject(new Error('timeout: ' + url)); }, 15000);
        });
        return Promise.race([
          native(url, {
            method: opts.method || 'GET',
            headers: opts.headers || undefined,
            body: opts.body || undefined,
            credentials: 'same-origin',
          }).then(function (r) {
            return {
              ok: r.ok,
              status: r.status,
              json: function () { return r.json(); },
              text: function () { return r.text(); },
            };
          }),
          timeout,
        ]);
      };
    })();
  }
  var millianFetch = window.__millianXhr;

  /* Third-party cart apps (the free-gift popup) only notice cart calls that
     go through the page's patched fetch. Ours go through the iframe above,
     so after one of ours lands we send a NO-OP quantity change for an
     existing line through the PAGE fetch: the app re-evaluates its rules
     and opens its popup right away instead of on the next page load. The
     app may hold that request until its popup closes, so this is
     fire-and-forget and never awaited by anything that paints. */
  function millianGiftPopupOpen() {
    var o = document.getElementById('v-popup-overlay');
    return Boolean(o && o.classList.contains('v-show'));
  }
  function millianGiftQty() {
    try {
      var el = document.querySelector('[data-millian-cart-state]');
      return el ? Number(JSON.parse(el.textContent).giftQty) || 0 : 0;
    } catch (e) { return 0; }
  }
  // opts.added: how many units the call that just landed put in the cart.
  // When that add crossed the free-gift threshold and the gift app has not
  // opened its popup shortly after the nudge (its rules failed to load, a
  // blocker interfered, …), fall back to what the app itself does after
  // every one of its own flows: reload the page. The drawer reopens after
  // the reload so the shopper is where they were, with the popup over it.
  window.millianNudgeCartApps = function (opts) {
    opts = opts || {};
    try {
      var ownGift = document.querySelector('[data-millian-cart-state]');
      if (ownGift && /"gift":\{/.test(ownGift.textContent)) return;
      var patched = Boolean(window.__myFetchBootstrap) ||
        Boolean(document.querySelector('script[src*="vex-auto-add-to-cart"]'));
      if (!patched) return;
      millianFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = cart && cart.items && cart.items[0];
          if (!line || !line.key) return;
          window.fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: line.key, quantity: line.quantity }),
          }).catch(function () {});

          var added = Number(opts.added) || 0;
          var giftQty = millianGiftQty();
          var after = Number(cart.item_count) || 0;
          var crossed = added > 0 && giftQty > 0 && after >= giftQty && after - added < giftQty;
          if (!crossed) return;
          setTimeout(function () {
            if (millianGiftPopupOpen() || window.__millianGiftReloaded) return;
            window.__millianGiftReloaded = true;
            try { sessionStorage.setItem('millian:reopen-drawer', '1'); } catch (e) { /* fine */ }
            window.location.reload();
          }, 1800);
        })
        .catch(function () {});
    } catch (e) { /* never let a nudge break the cart */ }
  };
  // After a gift-fallback reload, put the shopper back in the drawer.
  (function () {
    var flag = null;
    try { flag = sessionStorage.getItem('millian:reopen-drawer'); sessionStorage.removeItem('millian:reopen-drawer'); } catch (e) { /* fine */ }
    if (flag !== '1') return;
    var tries = 0;
    (function reopen() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      if (++tries < 40) setTimeout(reopen, 250);
    })();
  })();

  // Flight recorder: ALWAYS on, so a first-pageload-only bug can be
  // reproduced first and read afterwards. Tracked clicks (pointerdown AND
  // click — a pointerdown without its click means the click died), cart
  // calls and drawer events land in a ring buffer persisted to
  // sessionStorage. Reproduce the bug, then reload with ?millian-debug=1:
  // the panel prints the PREVIOUS pageload's trace and streams this one.
  if (!window.__millianTraceOn) {
    window.__millianTraceOn = true;
    (function () {
      // Snapshot the previous pageload's trace before this one overwrites it.
      try { window.__millianPrevTrace = sessionStorage.getItem('millian:trace') || ''; } catch (e) { window.__millianPrevTrace = ''; }
      var buf = [];
      var t0 = performance.now();
      var persistTimer = null;
      function persist() {
        persistTimer = null;
        try { sessionStorage.setItem('millian:trace', buf.slice(-400).join('\n')); } catch (e) { /* private mode */ }
      }
      window.__millianTrace = function (msg) {
        var line = (Math.round(performance.now() - t0) / 1000).toFixed(1) + 's ' + msg;
        buf.push(line);
        if (buf.length > 450) buf = buf.slice(-400);
        if (!persistTimer) persistTimer = setTimeout(persist, 250);
        if (window.__millianLog) window.__millianLog(line);
      };
      ['pointerdown', 'click'].forEach(function (t) {
        document.addEventListener(t, function (e) {
          var el = e.target.closest
            ? e.target.closest('#CartDrawer-Checkout, [data-millian-select], [data-millian-upsell-add], [data-millian-club-back], .millian-card-atc')
            : null;
          if (!el) return;
          window.__millianTrace(t + ' ' + (el.id || el.getAttribute('data-millian-select') || el.className.toString().slice(0, 30)));
        }, true);
      });
      document.addEventListener('update-cart-drawer', function (e) {
        window.__millianTrace('update-cart-drawer (' + ((e.detail && e.detail.source) || '?') + ')');
      });
      var realNet = window.__millianXhr;
      window.__millianXhr = function (url, opts) {
        var ts = performance.now();
        var u = url.split('?')[0];
        window.__millianTrace('-> ' + ((opts && opts.method) || 'GET') + ' ' + u);
        return realNet(url, opts).then(function (r) {
          window.__millianTrace('<- ' + r.status + ' ' + u + ' ' + Math.round(performance.now() - ts) + 'ms');
          return r;
        }, function (err) {
          window.__millianTrace('xx ' + u + ' ' + err.message);
          throw err;
        });
      };
      window.__millianTraceBuf = function () { return buf; };
    })();
  }
  millianFetch = window.__millianXhr;

  // Viewer: ?millian-debug=1 renders the recorder on screen — previous
  // pageload's trace first, then this pageload streaming live.
  if (!window.__millianDebug && /millian-debug/.test(location.search)) {
    window.__millianDebug = true;
    (function () {
      var panel = document.createElement('div');
      panel.setAttribute('style', 'position:fixed;left:8px;bottom:8px;z-index:2147483647;background:rgba(0,0,0,.88);color:#8f8;font:10px/1.5 monospace;padding:8px;border-radius:8px;max-width:70vw;max-height:38vh;overflow:auto;pointer-events:none;white-space:pre-wrap;');
      function mount() { (document.body || document.documentElement).appendChild(panel); }
      if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);
      window.__millianLog = function (line) {
        try { console.log('[millian-debug]', line); } catch (e) { /* noop */ }
        panel.textContent += line + '\n';
        panel.scrollTop = panel.scrollHeight;
      };
      if (window.__millianPrevTrace) {
        panel.textContent = '===== PREVIOUS PAGELOAD =====\n' + window.__millianPrevTrace + '\n===== THIS PAGELOAD =====\n';
      }
      (window.__millianTraceBuf ? window.__millianTraceBuf() : []).forEach(function (l) { panel.textContent += l + '\n'; });
    })();
  }

  // Drawer refresh for Dawn: re-render the cart-drawer section and swap it
  // in — SURGICALLY. A wholesale innerHTML swap eats any click that is
  // mid-flight (mousedown lands on a node the swap detaches, so the click
  // never fires — first sessions re-render a lot and felt dead). So:
  // only regions whose HTML actually changed are replaced, and never
  // while a pointer is down.
  if (!window.__millianDrawerRefresh) {
    window.__millianDrawerRefresh = true;
    var millianPointerDown = false;
    var millianPendingSwap = null;
    document.addEventListener('pointerdown', function () { millianPointerDown = true; }, true);
    function millianFlushSwap() {
      millianPointerDown = false;
      if (millianPendingSwap) {
        var run = millianPendingSwap;
        millianPendingSwap = null;
        // NOT setTimeout(0): the click event dispatches AFTER pointerup as
        // a separate task, so a zero-delay swap can still detach the node
        // mid-click sequence and eat it. 150ms clears the whole gesture.
        setTimeout(run, 150);
      }
    }
    document.addEventListener('pointerup', millianFlushSwap, true);
    document.addEventListener('pointercancel', millianFlushSwap, true);

    document.addEventListener('update-cart-drawer', function () {
      millianFetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          function swap() {
            var drawer = document.getElementById('CartDrawer');
            if (drawer && sections['cart-drawer']) {
              var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
              var next = doc.querySelector('#CartDrawer');
              var curEl = document.querySelector('cart-drawer');
              var nextEl = doc.querySelector('cart-drawer');
              // Empty <-> filled changes structure OUTSIDE the regions
              // (Dawn's .drawer__inner-empty only renders when empty), so a
              // region swap leaves an is-empty drawer with no empty-state
              // markup: an invisible drawer behind a stuck overlay. Full
              // swap on any is-empty transition.
              var emptinessChanged =
                curEl && nextEl &&
                curEl.classList.contains('is-empty') !== nextEl.classList.contains('is-empty');
              if (next) {
                var matched = 0;
                if (!emptinessChanged) {
                  // Region-wise: replace only what changed.
                  var regions = ['#CartDrawer-CartItems', '.drawer__footer'];
                  regions.forEach(function (sel) {
                    var cur = drawer.querySelector(sel);
                    var nxt = next.querySelector(sel);
                    if (cur && nxt) {
                      matched++;
                      if (cur.innerHTML !== nxt.innerHTML) cur.innerHTML = nxt.innerHTML;
                    }
                  });
                }
                if (emptinessChanged || matched < 2) drawer.innerHTML = next.innerHTML;
              }
              if (curEl && nextEl) {
                var nowEmpty = nextEl.classList.contains('is-empty');
                curEl.classList.toggle('is-empty', nowEmpty);
                // An emptied cart has no club step to stand on.
                if (nowEmpty) curEl.classList.remove('is-club-step');
              }
            }
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && sections['cart-icon-bubble']) {
              var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var bnext = bdoc.querySelector('.shopify-section');
              if (bnext) bubble.innerHTML = bnext.innerHTML;
            }
          }
          if (millianPointerDown) {
            millianPendingSwap = swap;
          } else {
            swap();
          }
        })
        .catch(function (e) { console.error('[millian] drawer refresh:', e); });
    });
  }

  // Member release wall (2026-10-24): "Join the club" on a members-only
  // product adds the membership line (on its selling plan) AND that bottle
  // to the cart in one call, marks the cart as the club path, opens the
  // drawer and flips the page to its buy box (html.millian-club-selected).
  if (!window.__millianJoinRelease) {
    window.__millianJoinRelease = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-millian-join-release]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var clubVariant = Number(btn.getAttribute('data-club-variant'));
      var clubPlan = Number(btn.getAttribute('data-club-plan'));
      var productVariant = Number(btn.getAttribute('data-product-variant'));
      if (!clubVariant || !productVariant) {
        window.location.href = '/pages/club';
        return;
      }
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'ADDING…';
      var items = [{ id: clubVariant, quantity: 1 }, { id: productVariant, quantity: 1 }];
      if (clubPlan) items[0].selling_plan = clubPlan;
      // Hand-added: the cart shows the joined card, not the Club | Guest switcher.
      items[0].properties = { _millian_manual: '1' };
      millianFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { millian_path: 'club' } }),
      })
        .catch(function () { /* the add still goes ahead */ })
        .then(function () {
          return millianFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: items }),
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('join release add failed: ' + res.status);
          document.documentElement.classList.add('millian-club-selected');
          window.__millianClubSeen = true;
          document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-join-release' } }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          if (typeof window.millianNudgeCartApps === 'function') window.millianNudgeCartApps({ added: 2 });
          setTimeout(millianApplyMemberCodes, 400);
        })
        .catch(function (err) {
          console.error('[millian] join release:', err);
          window.location.href = '/pages/club';
        })
        .then(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  }

  // Millian membership selector: delegated once — survives ajax re-renders.
  if (!window.__millianCartSelector) {
    window.__millianCartSelector = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-millian-select]');
      if (!btn) return;
      e.preventDefault();
      var box = btn.closest('[data-millian-selector-box]');
      if (!box || box.dataset.millianBusy === '1') return;
      var wantMember = btn.getAttribute('data-millian-select') === 'member';
      var lineKey = box.getAttribute('data-line-key');
      // Instant feedback: flip the tabs NOW; the drawer re-render that
      // follows the cart update confirms (or, on error, corrects) it.
      box.querySelectorAll('[data-millian-select]').forEach(function (t) {
        var isMemberTab = t.getAttribute('data-millian-select') === 'member';
        t.classList.toggle('is-selected', isMemberTab === wantMember);
      });
      var req = null;
      if (wantMember && !lineKey) {
        req = millianFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              {
                id: Number(box.getAttribute('data-variant-id')),
                quantity: 1,
                selling_plan: Number(box.getAttribute('data-selling-plan')),
              },
            ],
          }),
        });
      } else if (!wantMember && lineKey) {
        req = millianFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
      }
      box.dataset.millianBusy = '1';
      // The choice lives on the cart (attributes survive re-renders and
      // reloads): 'guest' is the explicit opt-out that stops the default
      // club pre-selection from adding the membership line again.
      millianFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { millian_path: wantMember ? 'club' : 'guest' } }),
      })
        .then(function () { return req; })
        .then(function (res) {
          if (res && !res.ok) throw new Error('cart update failed: ' + res.status);
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian' } }));
          window.millianNudgeCartApps();
        })
        .catch(function (err) {
          console.error('[millian] selector:', err);
          // The optimistic flip was wrong — re-render restores the truth.
          document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-error' } }));
        })
        .then(function () {
          delete box.dataset.millianBusy;
        });
    });

    // Existing members never see the join selector. Codes the theme
    // applies, from the app's published pricing (one item minimum, a guest
    // rate and a club rate): members get their personal credit code plus
    // the members-only code; a guest with the club line in the cart gets
    // the join code (club rate on the joining order); other guests get the
    // guest code. Below the minimum, or with pricing off, nothing is
    // applied and whatever the theme applied earlier is cleared. Free
    // shipping is the store's rates and the gift is the gift app — never
    // codes. Also self-heals a membership line whose quantity crept above 1.
    // Anyone who already holds a membership (tagged server-side, or the app
    // reports a live contract) can never add a second one. CANCELLED and
    // EXPIRED members may rejoin.
    window.millianHasMembership = function () {
      if (window.__millianTaggedMember) return true;
      var m = window.__millianMemberState;
      return Boolean(m && m.isMember && ['PENDING', 'ACTIVE', 'PAST_DUE'].indexOf(m.status) >= 0);
    };

    var millianApplyTimer = null;
    function millianApplyMemberCodes() {
      var box = document.querySelector('[data-millian-selector-box]');
      var variantId = box ? box.getAttribute('data-variant-id') : '';
      var clubHandle = box ? box.getAttribute('data-product-handle') : '';
      var sellingPlan = box ? box.getAttribute('data-selling-plan') : '';
      var releaseHandles = [];
      // Rendered state can be STALE — /cart.js is the truth for what's in
      // the cart; the rendered config only supplies the pricing rules.
      var pricing = null;
      var gift = null;
      var clubOff = Boolean(window.__millianClubOff);
      var clubMode = 'push';
      var stateEl = document.querySelector('[data-millian-cart-state]');
      if (stateEl) {
        try {
          var st = JSON.parse(stateEl.textContent);
          pricing = st.pricing || null;
          gift = st.gift || null;
          clubOff = clubOff || Boolean(st.clubOff);
          if (st.clubMode === 'quiet') clubMode = 'quiet';
          // No selector box on a memberships-off theme: the state carries
          // the club identifiers instead.
          if (!variantId && st.clubVariantId) variantId = String(st.clubVariantId);
          if (!clubHandle && st.clubHandle) clubHandle = String(st.clubHandle);
          if (!sellingPlan && st.clubSellingPlanId) sellingPlan = String(st.clubSellingPlanId);
          if (Array.isArray(st.memberReleaseHandles)) releaseHandles = st.memberReleaseHandles;
        } catch (e) { pricing = null; }
      }

      millianFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var clubLine = null;
          var count = 0;
          cart.items.forEach(function (it) {
            var isClub =
              (variantId && String(it.variant_id) === variantId) ||
              (clubHandle && it.handle === clubHandle);
            if (isClub) { clubLine = it; return; }
            count += it.quantity;
          });

          // Memberships are off for this theme: a membership line can only
          // have come from elsewhere (another theme in an A/B test, an old
          // cart). It has no UI here, so it must not ride to checkout.
          if (clubOff && clubLine) {
            return millianFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: clubLine.key, quantity: 0 }),
            }).then(function () {
              document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-club-off' } }));
            });
          }

          // A member never carries a second membership, however it got in
          // (club page, product page, an old cart).
          if (clubLine && window.millianHasMembership()) {
            return millianFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: clubLine.key, quantity: 0 }),
            }).then(function () {
              if (window.millianToast) window.millianToast('You’re already a Millian Club member');
              document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-member-has-club' } }));
            });
          }

          // Self-heal a membership line whose quantity crept above 1.
          if (clubLine && clubLine.quantity > 1) {
            return millianFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: clubLine.key, quantity: 1 }),
            }).then(function () {
              document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-qty-fix' } }));
            });
          }

          var clubSelected = Boolean(clubLine);
          document.documentElement.classList.toggle('millian-club-selected', clubSelected);

          var member = window.__millianMemberState;
          var isMember = Boolean(member && member.isMember);

          // Member releases ride on the membership (2026-10-24): a non-member
          // can only have one in the cart because they tapped Join, so if the
          // membership line goes (Remove, Pay as guest) the member-only
          // bottles go with it. Members keep theirs. Waits for the member
          // check so a member is never stripped during the proxy round trip.
          if (!clubLine && member && !isMember && releaseHandles.length) {
            var lockedLines = cart.items.filter(function (it) { return releaseHandles.indexOf(it.handle) >= 0; });
            if (lockedLines.length) {
              var updates = {};
              lockedLines.forEach(function (it) { updates[it.key] = 0; });
              return millianFetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ updates: updates }),
              }).then(function () {
                document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-release-removed' } }));
                setTimeout(millianApplyMemberCodes, 300);
              });
            }
          }

          // Club mode "push" (daily join KPI not yet met, published by the
          // app): a signed-out non-member with perfumes in the cart, no
          // membership line and no explicit "Pay as guest" choice (cart
          // attribute millian_path=guest, set by the tab or by removing the
          // line while perfumes remain) gets the membership line added.
          // "quiet": nothing is added — the /club page is the only way in.
          // Waits for the member check so a member never gets a second
          // subscription; never on a memberships-off theme; guarded so a
          // failing add cannot loop.
          if (!clubOff && clubMode === 'push' && !window.millianHasMembership()) {
            var path = (cart.attributes && cart.attributes.millian_path) || '';
            if (clubLine) {
              window.__millianClubSeen = true;
            } else if (count === 0) {
              window.__millianClubSeen = false;
            } else if (window.__millianClubSeen && path !== 'guest') {
              window.__millianClubSeen = false;
              return millianFetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ attributes: { millian_path: 'guest' } }),
              }).then(function () { setTimeout(millianApplyMemberCodes, 100); });
            }
            if (member && !isMember && !clubLine && count > 0 && path !== 'guest') {
              if (!variantId || !sellingPlan) {
                var tries = (window.__millianAutoClubTries || 0) + 1;
                window.__millianAutoClubTries = tries;
                if (tries <= 4) setTimeout(millianApplyMemberCodes, 700);
              } else if (!window.__millianAutoClub) {
                window.__millianAutoClub = true;
                window.__millianAutoClubTries = 0;
                return millianFetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  credentials: 'same-origin',
                  body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, selling_plan: Number(sellingPlan) }] }),
                }).then(function (res) {
                  if (res.ok) window.__millianAutoClub = false;
                  window.__millianClubSeen = true;
                  document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-club-default' } }));
                  if (typeof window.millianNudgeCartApps === 'function') window.millianNudgeCartApps();
                  setTimeout(millianApplyMemberCodes, 300);
                });
              }
            }
          }

          var desired = [];
          if (isMember && member.applyCredit && member.code) desired.push(member.code);
          var qualifies = pricing && pricing.minItems && count >= pricing.minItems;
          // Member rate only for ACTIVE members (see the proxy handler);
          // everyone else with a member record prices as a guest while
          // their credit code (above) keeps working.
          var pricingMember = isMember && member.status === 'ACTIVE';
          if (qualifies) {
            if (pricingMember && pricing.memberCode) desired.push(pricing.memberCode);
            else if (clubSelected && pricing.joinCode) desired.push(pricing.joinCode);
            else if (pricing.guestCode) desired.push(pricing.guestCode);
          }
          // Free bottle: the buy-N-get-1 code once the cart holds N+1 bottles.
          if (gift && gift.code && count >= Number(gift.buyQuantity) + 1) desired.push(gift.code);

          var sig = desired.join(',');
          // In-memory fallback FIRST: when sessionStorage throws (private
          // browsing / blocked storage) the memory copy still breaks the
          // apply -> re-render -> apply loop.
          var prev = window.__millianAppliedSig || null;
          try { prev = sessionStorage.getItem('millian:codes') || prev; } catch (e) { /* memory fallback */ }
          prev = prev || '';

          // What the cart ACTUALLY carries. The remembered signature alone is
          // not enough: Shopify drops or un-applies a code when the discount
          // is edited or rebuilt in admin (2026-10-18: 3 items, no 15% off,
          // because sessionStorage said MILLIAN-GUEST was already on). Any
          // wanted code missing from the applicable set gets re-applied,
          // throttled so a code Shopify keeps rejecting cannot loop.
          var upper = function (c) { return String(c || '').toUpperCase(); };
          var applied = [];
          var inCart = [];
          (cart.discount_codes || []).forEach(function (d) {
            if (!d || !d.code) return;
            inCart.push(upper(d.code));
            if (d.applicable !== false) applied.push(upper(d.code));
          });
          var wantSet = desired.map(upper);
          var prevSet = prev ? prev.split(',').map(upper) : [];
          var missing = wantSet.filter(function (c) { return applied.indexOf(c) < 0; });
          if (sig === prev) {
            if (!missing.length) return;
            var last = window.__millianReapplyAt || 0;
            if (Date.now() - last < 30000) return; // one retry per 30s, no loop
          } else if (!sig && !prev && !missing.length) {
            return; // nothing applied, nothing to clear
          }
          window.__millianReapplyAt = Date.now();
          // Codes the shopper added themselves survive; only codes this
          // runtime applied earlier and no longer wants are dropped.
          var keep = inCart.filter(function (c) {
            return wantSet.indexOf(c) < 0 && prevSet.indexOf(c) < 0;
          });
          var send = wantSet.concat(keep).join(',');
          return millianFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: send }),
          }).then(function (res) {
            if (!res.ok) {
              return res.text().then(function (t) {
                throw new Error('discount apply failed: ' + res.status + ' ' + String(t).slice(0, 200));
              });
            }
            window.__millianApplyRetries = 0;
            window.__millianAppliedSig = sig;
            try { sessionStorage.setItem('millian:codes', sig); } catch (e) { /* memory fallback holds */ }
            document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-codes' } }));
          });
        })
        .catch(function (err) {
          console.error('[millian] code auto-apply:', err);
          // A just-rotated code can take a few seconds to become applicable,
          // and a cart still holding the DEAD previous code makes every cart
          // update fail. Strip the cart's codes (best effort), then retry
          // with backoff until the new code lands.
          var attempt = (window.__millianApplyRetries || 0) + 1;
          if (attempt > 4) return;
          window.__millianApplyRetries = attempt;
          millianFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: '' }),
          })
            .then(function () {
              window.__millianAppliedSig = '';
              try { sessionStorage.setItem('millian:codes', ''); } catch (e) { /* memory fallback holds */ }
            })
            .catch(function () { /* clearing is best effort */ })
            .then(function () {
              setTimeout(millianApplyMemberCodes, 1500 * attempt);
            });
        });
    }

    function millianQueueApply() {
      clearTimeout(millianApplyTimer);
      millianApplyTimer = setTimeout(millianApplyMemberCodes, 300);
    }

    // Prize-draw countdown in the cart card. Elements carry data-deadline
    // (YYYY-MM-DD HH:MM, visitor-local); the drawer re-renders by ajax, so
    // the ticker re-queries the DOM every second instead of caching nodes.
    (function () {
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var els = document.querySelectorAll('[data-millian-cart-count][data-deadline]');
        if (!els.length) return;
        var now = Date.now();
        els.forEach(function (el) {
          var raw = (el.getAttribute('data-deadline') || '').trim();
          var deadline = new Date(raw.replace(' ', 'T'));
          if (isNaN(deadline.getTime())) return;
          var left = deadline.getTime() - now;
          if (left <= 0) {
            el.textContent = el.getAttribute('data-ended') || 'Winner being drawn';
            return;
          }
          var sec = Math.floor(left / 1000);
          var parts = {
            d: String(Math.floor(sec / 86400)),
            h: pad(Math.floor((sec % 86400) / 3600)),
            m: pad(Math.floor((sec % 3600) / 60)),
            s: pad(sec % 60),
          };
          if (!el.querySelector('[data-u]')) {
            el.innerHTML =
              '<span class="millian-sel__cd-label">Drawn in</span>' +
              '<span class="millian-sel__cd">' +
              ['d', 'h', 'm', 's'].map(function (u) {
                return '<b data-u="' + u + '"><span>0</span><i>' + u + '</i></b>';
              }).join('') +
              '</span>';
          }
          ['d', 'h', 'm', 's'].forEach(function (u) {
            var n = el.querySelector('[data-u="' + u + '"] > span');
            if (n && n.textContent !== parts[u]) n.textContent = parts[u];
          });
          el.classList.add('is-live');
        });
      }
      tick();
      setInterval(tick, 1000);
    })();
    document.addEventListener('update-cart-drawer', millianQueueApply);
    document.addEventListener('cart-update', millianQueueApply);
    // The desktop drawer's quantity buttons fire none of those events and
    // the header bubble is not re-rendered either (2026-10-18: a fresh
    // session reached 3 items with no 15% off). Watch the cart requests
    // themselves: any add/change/update/clear from the page queues a
    // re-check. The runtime's own cart calls go through the iframe fetch,
    // so they are not seen here and cannot loop.
    (function () {
      var re = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
      var hit = function (url) {
        try { if (re.test(String(url))) setTimeout(millianQueueApply, 250); } catch (e) { /* ignore */ }
      };
      if (!window.__millianCartHook) {
        window.__millianCartHook = true;
        var origFetch = window.fetch;
        if (typeof origFetch === 'function') {
          window.fetch = function (input, init) {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var p = origFetch.apply(this, arguments);
            if (p && typeof p.then === 'function') p.then(function () { hit(url); }, function () {});
            else hit(url);
            return p;
          };
        }
        var XHR = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
        if (XHR && XHR.open && XHR.send) {
          var origOpen = XHR.open;
          var origSend = XHR.send;
          XHR.open = function (method, url) { this.__millianUrl = url; return origOpen.apply(this, arguments); };
          XHR.send = function () {
            var url = this.__millianUrl;
            if (url && re.test(String(url))) this.addEventListener('loadend', function () { hit(url); });
            return origSend.apply(this, arguments);
          };
        }
        // Form posts to /cart/add reload the page; nothing to hook there.
      }
    })();
    var millianCountEl = document.querySelector('.cart-count-bubble');
    if (millianCountEl) {
      new MutationObserver(millianQueueApply).observe(millianCountEl.parentElement || millianCountEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    millianFetch('/apps/millian/member', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      // A failed check is UNKNOWN, not "not a member": leaving the state
      // unset keeps the auto-add (which waits on it) from firing.
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) {
        if (!s) return;
        window.__millianMemberState = s;
        // The members-only code keys on the club tag, which only ACTIVE,
        // unfrozen members carry. A cancelled (grace-window), past-due or
        // frozen member still has a member record and spendable credit, but
        // for PRICING they are a guest: guest rate, guest labels, and the
        // join box instead of the thank-you card.
        var pricingMember = Boolean(s && s.isMember && s.status === 'ACTIVE');
        try { sessionStorage.setItem('millian:member', pricingMember ? '1' : '0'); } catch (e) {}
        document.documentElement.classList.toggle('millian-is-member', pricingMember || Boolean(window.__millianTaggedMember));
        // The header's account popover waits on this to decide whether the
        // Millian Club link is shown on a memberships-off theme.
        document.dispatchEvent(new CustomEvent('millian:member-state'));
        millianApplyMemberCodes();
      })
      .catch(function () {});
  }

/* Popular Scents upsell add-to-cart (moved from the snippet: it only
   renders with a non-empty cart, so its inline script was dead on
   sessions that began empty). */
    // Upsell add-to-cart: adds with the attribution property and reports
    // the event to the app. Delegated once — survives drawer re-renders.
    // Free-bottle picker: fetched on demand as a section, mounted over the
    // drawer. Choosing adds the bottle; the gift code (applied by the code
    // sync above once the cart holds N+1 bottles) makes it $0.
    if (!window.__millianGiftPicker) {
      window.__millianGiftPicker = true;
      var giftNet = function () { return window.__millianXhr || fetch; };
      var giftOpen = null;
      function giftClose() {
        if (!giftOpen) return;
        var el = giftOpen; giftOpen = null;
        el.classList.remove('is-open');
        document.documentElement.classList.remove('millian-gift-lock');
        setTimeout(function () { el.remove(); }, 250);
      }
      function giftShow() {
        if (giftOpen) return;
        giftNet()('/?section_id=millian-gift-picker', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('picker ' + r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sheet = doc.querySelector('[data-millian-gift-sheet]');
            if (!sheet) throw new Error('picker markup missing');
            document.body.appendChild(sheet);
            giftOpen = sheet;
            document.documentElement.classList.add('millian-gift-lock');
            requestAnimationFrame(function () { sheet.classList.add('is-open'); });
            var x = sheet.querySelector('.millian-gift__x'); if (x) x.focus();
          })
          .catch(function (err) { console.error('[millian] gift picker:', err); });
      }
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-millian-gift-open]')) { e.preventDefault(); giftShow(); return; }
        if (!giftOpen) return;
        if (e.target.closest('[data-millian-gift-close]')) { e.preventDefault(); giftClose(); return; }
        var chip = e.target.closest('[data-millian-gift-chip]');
        if (chip) {
          var word = chip.getAttribute('data-millian-gift-chip');
          giftOpen.querySelectorAll('[data-millian-gift-chip]').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
          giftOpen.querySelectorAll('.millian-gift__card').forEach(function (card) {
            card.hidden = Boolean(word) && (card.getAttribute('data-millian-gift-notes') || '').indexOf(word) === -1;
          });
          return;
        }
        var pick = e.target.closest('[data-millian-gift-choose]');
        if (pick && !pick.disabled) {
          var sheet = giftOpen;
          sheet.querySelectorAll('[data-millian-gift-choose]').forEach(function (b) { b.disabled = true; });
          pick.textContent = 'Adding…';
          giftNet()('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: Number(pick.getAttribute('data-variant-id')), quantity: 1, properties: { _millian_gift: '1' } }] }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('gift add ' + res.status);
              pick.textContent = 'Added \u2713';
              pick.classList.add('is-added');
              var card = pick.closest('.millian-gift__card'); if (card) card.classList.add('is-chosen');
              document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-gift' } }));
              setTimeout(giftClose, 900);
            })
            .catch(function (err) {
              console.error('[millian] gift add:', err);
              pick.textContent = 'Choose';
              sheet.querySelectorAll('[data-millian-gift-choose]').forEach(function (b) { b.disabled = false; });
            });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && giftOpen) giftClose(); });
    }

    // "Remove" on the club-in-your-order card: take the membership line out.
    if (!window.__millianClubRemove) {
      window.__millianClubRemove = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-millian-club-remove]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        var box = btn.closest('[data-millian-selector-box]');
        var key = box ? box.getAttribute('data-line-key') : '';
        if (!key) return;
        btn.disabled = true;
        btn.textContent = 'Removing…';
        var net = window.__millianXhr || fetch;
        net('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: 0 }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('club remove failed: ' + res.status);
            document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-club-remove' } }));
          })
          .catch(function (err) {
            console.error('[millian] club remove:', err);
            btn.disabled = false;
            btn.textContent = 'Remove';
          });
      });
    }

    if (!window.__millianUpsell) {
      window.__millianUpsell = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-millian-upsell-add]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        btn.disabled = true;
        var variantId = Number(btn.getAttribute('data-variant-id'));
        var handle = btn.getAttribute('data-product-handle') || '';
        // __millianXhr (from the club selector, rendered earlier in the
        // drawer) bypasses third-party fetch/XHR wrappers that stall cart
        // calls on first sessions; plain fetch is only the fallback.
        var upsellFetch = window.__millianXhr || fetch;
        upsellFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: { _millian_upsell: '1' } }],
          }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('upsell add failed: ' + res.status);
            // Fire-and-forget tracking beacon to the app proxy.
            upsellFetch('/apps/millian/upsell', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              keepalive: true,
              body: JSON.stringify({ variantId: variantId, productHandle: handle, quantity: 1 }),
            }).catch(function () {});
            document.dispatchEvent(new CustomEvent('update-cart-drawer', { detail: { source: 'millian-upsell' } }));
            window.millianNudgeCartApps({ added: 1 });
          })
          .catch(function (err) {
            console.error('[millian] upsell:', err);
            btn.disabled = false;
          });
      });
    }

/* Cart drawer: the summary bar overlays the bottom of the cart (see
   cart-drawer.liquid); keep the cart's bottom space equal to the bar's
   height. Drawer re-renders replace the bar, so re-observe on every change. */
(function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || !window.ResizeObserver) return;
  var watched = null;
  var sizer = new ResizeObserver(function () {
    var footer = drawer.querySelector('.drawer__footer');
    drawer.style.setProperty('--millian-footer-h', (footer ? footer.offsetHeight : 0) + 'px');
  });
  function watch() {
    var footer = drawer.querySelector('.drawer__footer');
    if (footer === watched) return;
    if (watched) sizer.unobserve(watched);
    watched = footer;
    if (footer) sizer.observe(footer);
  }
  new MutationObserver(watch).observe(drawer, { childList: true, subtree: true });
  watch();
})();
